import { render, staticRenderFns } from "./UserLoginHandler.vue?vue&type=template&id=166fadbe"
import script from "./UserLoginHandler.vue?vue&type=script&lang=js"
export * from "./UserLoginHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/89/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166fadbe')) {
      api.createRecord('166fadbe', component.options)
    } else {
      api.reload('166fadbe', component.options)
    }
    module.hot.accept("./UserLoginHandler.vue?vue&type=template&id=166fadbe", function () {
      api.rerender('166fadbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/login/UserLoginHandler.vue"
export default component.exports